import { Grid } from '@mui/material';
import { useUsersContactInfoQuery } from 'api/queries/users';
import AccountChangePasswordForm from 'components/forms/AccountFactory/AccountChangePasswordForm';
import AccountDetailsForm from 'components/forms/AccountFactory/AccountDetailsForm';

function SettingsAccountView() {
  const { data: contactInfo, isSuccess } = useUsersContactInfoQuery();

  if (!isSuccess) return null;

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} md='auto'>
        <AccountDetailsForm defaultValues={contactInfo} />
      </Grid>
      <Grid item xs={12} md='auto'>
        <AccountChangePasswordForm />
      </Grid>
    </Grid>
  );
}

export default SettingsAccountView;
